// Rating display helpers for guest reviews across platforms with different
// maxima: Airbnb scores out of 5, VRBO and Booking.com out of 10 (Trello 18593,
// Reviews v4). Keeping the maths here (not inline in the component) makes it
// unit-testable and keeps the scale in one place.

// Rating as a 0–1 fraction of the platform's scale, for scale-correct sorting.
export function ratingFraction(rating: number, scale: number): number {
  return scale > 0 ? rating / scale : 0;
}

// The pill label, e.g. "5/5" (Airbnb) or "10/10" (VRBO / Booking.com).
export function ratingLabel(rating: number, scale: number): string {
  return `${rating}/${scale}`;
}

// Colour by how close the rating is to the platform's maximum, so the pill reads
// the same on any scale: top marks green, mid amber, low grey.
export function ratingVariant(rating: number, scale: number): string {
  const fraction = ratingFraction(rating, scale);
  if (fraction >= 0.9) {
    return 'impact-high';
  }
  if (fraction >= 0.6) {
    return 'impact-medium';
  }
  return 'impact-low';
}
